import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { FaAward } from "react-icons/fa";

const certificates = [
  {
    title: "Data Analyst in Power BI",
    issuer: "DataCamp",
    issued: "Nov 2025",
    description:
      "Data visualization, data cleaning, data modeling, and data analysis.",
    credentialUrl: "https://www.datacamp.com/completed/statement-of-accomplishment/track/2b3d5d7192ec4f7b3b3d75dd05e9acba52bc758e",
    tags: ["Power BI", "DAX", "Power Query"],
  },
  {
    title: "Microsoft Azure AI Essentials",
    issuer: "Microsoft and LinkedIn",
    issued: "Oct 2025",
    description:
      "Foundational AI concepts, Azure AI services, and AI-powered solutions.",
    credentialUrl: "https://www.linkedin.com/learning/certificates/79917b957ec61f378af4510b228e3e11861852f871e6970c6c821fa35dfe5d0d",
    tags: ["Azure AI Studio", "Machine Learning", "Generative AI"],
  },
  {
    title: "Data Engineering",
    issuer: "LinkedIn",
    issued: "Apr 2026",
    description:
      "Data engineering concepts, ETL, DAG",
    credentialUrl: "https://www.linkedin.com/learning/certificates/da1a2aa02fb16d989933276fc78b53224435bfc35f2fb10d13f1df09db41c6be",
    tags: ["Airflow", "Data Pipelines", "Data Warehousing"],
  },
  {
    title: "Introduction to MCP",
    issuer: "Anthropic",
    issued: "2026",
    description:
      "Foundational MCP concepts, Tools, Resources and Prompts",
    credentialUrl: "https://verify.skilljar.com/c/tk3jij24ytgj",
    tags: ["Claude Code", "Model Context Protocol"],
  },
  {
    title: "MCP: Advanced Topics",
    issuer: "Anthropic",
    issued: "2026",
    description:
      "Advanced MCP concepts, Server-client communication, Transport mechanisms, Sampling",
    credentialUrl: "https://verify.skilljar.com/c/rc64uzcp7wqv",
    tags: ["Claude Code", "Model Context Protocol", "Sampling"],
  },
  {
    title: "Claude Code in Action",
    issuer: "Anthropic",
    issued: "2026",
    description:
      "Claude Code's context management approach, Extend functionality thorugh MCP servers and GitHub integration",
    credentialUrl: "https://verify.skilljar.com/c/g3x7833k9zwk",
    tags: ["Claude Code", "Git", "MCP Servers", "Hooks"],
  },
];

const Certificates = () => {
  return (
    <div>
      <Navbar />
      <div className="text-white max-w-[1200px] mt-[-96px] mb-[20px] w-full h-full mx-auto px-4 font-main">
        <div className="pt-[150px] text-center">
          <h1 className="text-[#00df9a] uppercase text-3xl">Certificates</h1>
          {/* <p className="mt-4 text-gray-300 max-w-2xl mx-auto">
            Professional certifications and coursework credentials I have completed.
          </p> */}
        </div>

        <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-8 mt-12">
          {certificates.map((cert, index) => (
            <div
              key={index}
              className="bg-[#111827] rounded-xl shadow-lg hover:shadow-2xl hover:scale-[1.02] transition duration-300 overflow-hidden flex flex-col"
            >
              <div className="p-6 flex flex-col flex-grow">
                <div className="flex items-start gap-3">
                  <span className="text-[#00df9a] mt-1 shrink-0">
                    <FaAward size={28} aria-hidden />
                  </span>
                  <div className="min-w-0">
                    <h2 className="text-2xl font-semibold text-[#00df9a] leading-tight">
                      {cert.title}
                    </h2>
                    <p className="mt-1 text-gray-200 font-medium">{cert.issuer}</p>
                    <p className="text-sm text-gray-400 mt-0.5">Issued {cert.issued}</p>
                  </div>
                </div>

                <p className="mt-4 text-gray-300 flex-grow">{cert.description}</p>

                <div className="mt-4 flex flex-wrap gap-2">
                  {cert.tags.map((t, i) => (
                    <span
                      key={i}
                      className="bg-[#1f2937] text-gray-200 px-3 py-1 text-sm rounded-full"
                    >
                      {t}
                    </span>
                  ))}
                </div>

                {cert.credentialUrl ? (
                  <div className="mt-5">
                    <a
                      href={cert.credentialUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-block bg-[#2563eb] text-white px-4 py-2 rounded-lg hover:bg-[#1d4ed8] transition"
                    >
                      Verify credential
                    </a>
                  </div>
                ) : null}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-[40px] mb-[30px]">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Certificates;
